import { Button, Modal, Snackbar } from '@mui/material';
import { Tooltip } from '@mui/material';
import { Visibility, QuestionAnswer, Description, InfoOutlined } from '@mui/icons-material';
import { Col, Row, Drawer } from 'antd';
import Loading from 'components/Loading';
import { filter, find, get, groupBy, map, findIndex, uniqBy, cloneDeep, orderBy } from "lodash";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useRef, useState, Suspense } from 'react';
import { connect, useDispatch } from 'react-redux';
import dayjs from 'utils/dayjsConfig';
import { useLocation, useNavigate } from 'react-router-dom';

const AgGridReact = React.lazy(() => import('ag-grid-react').then(module => ({ default: module.AgGridReact })));
import { useAllBook } from 'store/books/selectors';
import { useResources, useVideos } from 'store/resources/selectors';
import styled from 'styled-components';
import {
    datagrid_close,
    datagrid_logoColored,
    datagrid_searchIcon
} from "utils/assets/images";
import { getAssignmentLable, filterStoryClassQuizOrActivity, GRADE_PREF } from 'utils/lib/ebookHelper';
import { studentMatchesGradebookActiveFilter } from 'utils/methods/gradebookStudentActiveFilter';

import { handleListClassSubmissions, handleListSubmissionsByAssignmentAndClass, handleUpdateMetSubmission } from 'store/submissions/thunks';
//  -- Thunks -------------------------
import { handleListActivities, handleListCustomAssignment } from 'store/activities/thunks';
import { handleListClassActivities, handleUpdateClassActivity } from 'store/classActivities/thunks';
import { handleListClassQuizzes, handleUpdateClassQuiz } from 'store/classQuizzes/thunks';
import { handleListQuizzes } from 'store/quizzes/thunks';
import { handleListClassUsers } from 'store/userClasses/thunks';
import COLOR from "utils/constants/color";
import { useStory, useStandards } from 'store/story/selectors';
import GradeTable from 'features/GradeTableStory';
import { getStandardDescription, formatStandardDisplay, formatStateStandardDisplay, getAllStandardAbbrsFromStateStandard, filterStateStandardByEnabledStates } from 'utils/lib/standardHelper';
import SentryWrap from 'components/Sentry';
import SpinLoader from 'components/Loader/SpinLoader';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import AssignmentReview from 'features/forms/AssignmentReview';
import * as Sentry from '@sentry/react';
import ActivityForm from 'features/forms/Activity';
import QuizForm from 'features/forms/Quiz';
import { useUserPreference } from "store/userPreference/selectors"
import { Dropdown } from 'antd';
import { CaretDownOutlined, DownloadOutlined, DownOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { handleCreateUserPreference, handleUpdateUserPreference } from 'store/userPreference/thunks';
import { handleCreateDownloadList } from 'store/exams/thunks';
import { Alert } from '@mui/material';
import { handleUpdateSchoologyAssignment } from 'store/schoologyauth/thunks';
import StandardsModal from 'components/StandardsModal';
import { useOrgStandardCodes } from 'store/organizations/selectors';
import { af_grade } from 'utils/methods/math';
const RESULT = {
    fail: "🔴",
    pass: "🟢"
}

const ORDER_BY = [
    { key: "due_date", value: "Due Date" },
    { key: "start_date", value: "Start Date" },
    { key: "late_submission", value: "Late Date" },
]

const ORDER_BY_Filter = [
    { key: "asc", value: "Ascending" },
    { key: "desc", value: "Descending" },
]

const ModalContent = styled.div`
        align-items: center;
        background-color: #11ffee00;
        border-radius: 3px;
        display: inline-flex;
        flex-direction: column;
        left: 50%;
        padding: 16px;
        position: absolute;
        text-align: center;
        top: 50%;
        transform: translate(-50%, -50%);
    `;
const Search = styled.input`
    ::placeholder,
    ::-webkit-input-placeholder {
    color: ${COLOR.white};
    }
`;
const MessageContgainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${COLOR.white};
    border: 3px solid ${COLOR.indigo400};
    border-radius: 15px;
    padding: 16px;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.2);
    overflow: auto;
    padding: 12px;
    min-height: fit-content;
    max-height: 80%;
    `
const MenuItem = styled.div`
    display: flex;
    flex-direction: row;
    `;

    const PaddedBtn = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 8px;
    text-align: left;
    width: 100%;
`;
const NameItem = styled.div`
`;

const StudentStatusSelector = styled.div`
    min-height: 28px;
    min-width: 140px;
    border-radius: 20px;
    background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);
    cursor: pointer;
    display: flex;
    flex-direction: row;
    color: #fff;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 6px 12px;
    font-size: 13px;
    font-weight: 500;
    margin: 0;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    white-space: nowrap;
    box-shadow: 0 2px 4px rgba(74, 144, 226, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.1);
    
    &:hover {
        background: linear-gradient(135deg, #357abd 0%, #2c5aa0 100%);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
        border-color: rgba(255, 255, 255, 0.2);
    }
    
    &:active {
        transform: translateY(0);
        box-shadow: 0 2px 4px rgba(74, 144, 226, 0.2);
    }
`;
const sortname = (a, b) => {
    const nameA = a?.lastName?.toLowerCase()?.replace(/\s/g, '');
    const nameB = b?.lastName?.toLowerCase()?.replace(/\s/g, '');;
    if (nameA < nameB) { return -1 }
    else if (nameA > nameB) { return 1 }
    else { return 0 }
}

const groupAssignment = (submissions) => {
    return groupBy(submissions, 'userId');

}


export const GridStoryLevel = ({
    classActivities,
    classQuizzes,
    currentClass,
    currentOrg,
    classUsers,
    submissions,
    currentUser,
    activities,
    quizzes
}) => {
    const showAlert = useAlert();
    const [DataShow, setDataShow] = useState(false);
    const [listStudentUser, setListStudentUser] = useState([])
    const [filteredStudent, setFilteredStudent] = useState([])
    const [activeInactive, setActiveInactive] = useState('active')
    const standards = useStandards()
    const story = useStory()
    const userPreference = useUserPreference()
    const classQuizzesData = useMemo(() => filterStoryClassQuizOrActivity(classQuizzes, story), [classQuizzes, story])
    const classActivityData = useMemo(() => filterStoryClassQuizOrActivity(classActivities, story), [classActivities, story])
    const studentSubmissions = groupAssignment(submissions)
    const booksAllList = useAllBook()
    const videos = useVideos()
    const resources = useResources()
    const dispatch = useDispatch()
    const location = useLocation();
    const navigate = useNavigate();
    const [storyNavPrefetchLoading, setStoryNavPrefetchLoading] = useState(false);
    const submissionDetailFetchedRef = useRef(new Set());
    const classIdForFetchRef = useRef(null);
    const [dataLoading, setDataloading] = useState(false)
    const [searchInput, setSearchInput] = useState('')
    const [DataShow2, setDataShow2] = useState(false);
    const [assignmentData, setAssignmentData] = useState({});
    const [selectedAssignmentUserSubmission, setSelectedAssignmentSubmissions] = useState([])
    const [assignmentDrawer, toggleAssignmentDrawer] = useState(false);
    const [loading, setLoading] = useState(false);
    const [durationSection, setDurationSection] = useState(false);
    const [activityData, setActivityData] = useState({});
    const [activityDrawer, toggleActivityDrawer] = useState(false);
    const [labelDescriptionView, setLabelDescriptionView] = useState({
        open: false,
        describe: ""
    })
    const [standardsModal, setStandardsModal] = useState({
        open: false,
        standardAbbrs: [],
        stateStandard: null
    })
    const [quizDrawer, toggleQuizDrawer] = useState(false);
    const [quizData, setQuizData] = useState({});
    const [fetchSelectedRubric,setFetchRubricId] = useState(null);
    const [ datePrefrences,  setDatePrefrences] = useState("due_date");
    const [orderByFilter,  setOrderByDate] = useState("desc");
    const [updateOrderByLoader,setUpdateOrderByLoader] = useState(false);
    const [updateDateLoader,setUpdateDateLoader] = useState(false);
    const [updatePrefLoader, setUpdatePrefLoader] = useState(false);
    const [openPop, setOpen] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    const scale_1_5 = userPreference?.gradePref == "scale_1_5"
    const gradebook_a_f = userPreference?.gradePref === "gradebook_a_f"
    const selectedLabel = ORDER_BY.find((o) => o.key === datePrefrences)?.value || 'Due Date';
    const selectedOrderLabel = ORDER_BY_Filter.find((o) => o.key === orderByFilter)?.key || 'desc';

    useEffect(() => {
        if (userPreference && typeof userPreference.orderBy === "string") {
            if (userPreference.orderBy === "asc" || userPreference.orderBy === 'desc') {
                setOrderByDate(userPreference.orderBy)
            }
        }
        if (userPreference && typeof userPreference?.order_by_date === "string") {
            if (["start_date", "due_date", "late_submission"].includes(userPreference?.order_by_date)) {
                setDatePrefrences(userPreference?.order_by_date)
            }
        } else if (!userPreference || !userPreference?.order_by_date) {
            setDatePrefrences('due_date')
        }
    }, [userPreference])

    const storyAssignmentIdsSerialized = useMemo(() => {
        const ids = new Set();
        map(classActivityData, (a) => {
            const aid = get(a, "data.id") || get(a, "activityId") || get(a, "session_id");
            if (aid) ids.add(String(aid));
        });
        map(classQuizzesData, (q) => {
            const qid = get(q, "data.id") || get(q, "quizId") || get(q, "session_id");
            if (qid) ids.add(String(qid));
        });
        return Array.from(ids).sort().join("\u0001");
    }, [classActivityData, classQuizzesData]);

    useEffect(() => {
        const cid = get(currentClass, "id");
        if (!cid) return;
        if (cid !== classIdForFetchRef.current) {
            classIdForFetchRef.current = cid;
            submissionDetailFetchedRef.current = new Set();
        }
    }, [currentClass?.id]);

    useEffect(() => {
        const classId = get(currentClass, "id");
        if (!classId) return;

        const idsFromStory = storyAssignmentIdsSerialized
            ? storyAssignmentIdsSerialized.split("\u0001").filter(Boolean)
            : [];
        const navPref = get(location.state, "storyGradebookPrefetch");
        const navAssignmentId = navPref?.assignmentId != null ? String(navPref.assignmentId) : null;
        const navClassId = navPref?.classId != null ? String(navPref.classId) : null;

        const idsToFetchSet = new Set(idsFromStory);
        if (navAssignmentId && navClassId === String(classId)) {
            idsToFetchSet.add(navAssignmentId);
        }
        if (idsToFetchSet.size === 0) return;

        const fetchKey = (aid) => `${classId}:${aid}`;
        const pendingIds = Array.from(idsToFetchSet).filter(
            (aid) => !submissionDetailFetchedRef.current.has(fetchKey(aid))
        );
        if (pendingIds.length === 0) {
            if (navAssignmentId && navClassId === String(classId)) {
                navigate(location.pathname, { replace: true, state: {} });
            }
            return undefined;
        }

        let cancelled = false;
        void (async () => {
            try {
                setStoryNavPrefetchLoading(true);
                await Promise.allSettled(
                    pendingIds.map((assignmentId) =>
                        dispatch(handleListSubmissionsByAssignmentAndClass(assignmentId, classId))
                    )
                );
                if (cancelled) return;
                pendingIds.forEach((aid) => submissionDetailFetchedRef.current.add(fetchKey(aid)));
            } catch (error) {
                Sentry.captureException(error);
            } finally {
                if (!cancelled) {
                    setStoryNavPrefetchLoading(false);
                    if (navAssignmentId && navClassId === String(classId)) {
                        navigate(location.pathname, { replace: true, state: {} });
                    }
                }
            }
        })();
        return () => {
            cancelled = true;
            setStoryNavPrefetchLoading(false);
        };
    }, [
        currentClass?.id,
        storyAssignmentIdsSerialized,
        dispatch,
        navigate,
        location.pathname,
        get(location.state, "storyGradebookPrefetch.assignmentId"),
        get(location.state, "storyGradebookPrefetch.classId"),
    ]);

    const stickyCellRenderer = (p) => {
        const value = p.value;
        const usernamename = ` ${get(value, "lastName", "")}, ${get(value, "firstName", "")}`;
        return (
            <div className="quesBtns">
                <a>
                    <NameItem style={{ width: "80%" }}>{!value ? 'No of questions' : usernamename}</NameItem>
                    {value && get(value, "id") ? <Description style={{ color: "#fff" }} onClick={() => { handleoverAllShow(value); }} /> : null}
                </a>
            </div>
        )
    }
    const enabledStateCodes = useOrgStandardCodes();
    const getStandard = (abbr) => {
        if (!abbr) return null;
        
        if (typeof abbr === 'string' && abbr.includes(',')) {
            const standardAbbrs = abbr.split(',').map(s => s.trim()).filter(s => s);
            const descriptions = standardAbbrs.map(abbrItem => {
                const standardObj = find(standards, ["abbr", abbrItem]);
                return getStandardDescription(standardObj, enabledStateCodes);
            }).filter(desc => desc);
            
            return descriptions.length > 0 ? descriptions.join('\n\n') : null;
        } else {
            const standardObj = find(standards, ["abbr", typeof abbr === 'string' ? abbr.trim() : abbr]);
            return getStandardDescription(standardObj, enabledStateCodes);
        }
    }
    const modelCellRenderer = (p) => {
        const { value } = get(p.value, "submissionData", {})
        const numberOfQuestion = get(p.value, "numberOfQuestion")
        const level = get(p.value, "data.level")
        return (
            <div className="eyeShwDataUpr">
                <div className="eyeShwData">
                    <span>{numberOfQuestion >= 0 ? numberOfQuestion : (value >= 0 ? value : '-')}</span>
                    {level ? <Visibility onClick={() => { handleGradeValueShow(p.value); }} /> : null}
                </div>
                <p>{level}</p>
            </div>
        )
    }
    const QuestionHeader = () => {
        return (
            <div className="quesTxtIcon">
                <label><span>Question</span><QuestionAnswer /></label>
            </div>
        )
    }

    const [columnDefs, setColsDefs] = useState([
        {
            headerName: "Name of the story:",
            children: [
                {
                    headerName: "Name of the story:",
                    children: [{
                        headerName: "Page Number:",
                        field: "Date Assigned:",
                        cellRenderer: stickyCellRenderer,
                        width: 210,
                        pinned: 'left',
                    }],
                },
            ],
        },

    ])

    const [rowData, setRowData] = useState([
        { user: {}, '-': '' }
    ]);

    const [assignmentRowData, setAssignmentRowData] = useState([
    ]);
    const StandardCellRender = (p) => {
        const value = p.value;
        const rowData = p.data;
        const questionData = rowData?.question || rowData?.assignment?.data?.questions?.[rowData?.question_no] || rowData?.assignment?.submissionData?.submission?.assignment?.questions?.[rowData?.question_no];
        const stateStandard = questionData?.state_standard;
        
        if (!value && (!stateStandard || !Array.isArray(stateStandard) || stateStandard.length === 0)) {
            return <div className="quesTxtIcon"><label><span></span></label></div>;
        }
        
        let standardAbbrs = [];
        let formattedValue = null;
        let stateStandardData = null;
        
        if (stateStandard && Array.isArray(stateStandard) && stateStandard.length > 0) {
            const filteredStateStandard = filterStateStandardByEnabledStates(stateStandard, enabledStateCodes);
            stateStandardData = filteredStateStandard;
            standardAbbrs = getAllStandardAbbrsFromStateStandard(filteredStateStandard, enabledStateCodes);
            formattedValue = formatStateStandardDisplay(filteredStateStandard, standards, enabledStateCodes);
        } else if (value) {
            standardAbbrs = typeof value === 'string' && value.includes(',')
                ? value.split(',').map(s => s.trim()).filter(s => s)
                : [value];
            formattedValue = formatStandardDisplay(value, standards, enabledStateCodes);
        }
        
        if (!formattedValue) return <div className="quesTxtIcon"><label><span></span></label></div>;

        return (
            <div className="quesTxtIcon">
                <label>
                    <span>{formattedValue}</span>
                    <InfoOutlined 
                        onClick={() => {
                            setStandardsModal({ open: true, standardAbbrs, stateStandard: stateStandardData });
                        }}
                        style={{ cursor: 'pointer', marginLeft: '4px' }}
                    />
                </label>
            </div>
        )
    }
    const onMetChange = async (met, assignment, question_no, standard) => {
        const sub = get(assignment, "submissionData.submission")
        if (!sub) return;
        const answers = get(sub, "answers", [])
        if (!answers[question_no]) {
            answers[question_no] = {}
        }
        const alreadyMet = answers[question_no]?.met || [];
        if (alreadyMet) {
            const indx = findIndex(alreadyMet, { standard })
            if (indx >= 0) {
                alreadyMet[indx] = {
                    standard,
                    met
                }
                answers[question_no].met = alreadyMet;
            } else {
                alreadyMet.push({
                    standard,
                    met
                })
                answers[question_no].met = alreadyMet;
            }
        } else {
            answers[question_no].met = [{
                standard,
                met
            }];
        }

        const submi = await dispatch(handleUpdateMetSubmission(
            {
                id: sub.id,
                answers: answers,

            }
        ));
        assignment.submissionData.submission = submi;
        dispatch(handleListClassSubmissions(get(currentClass, "id"), true))
    }
    const onchangeIcon = (id, isPass) => {
        const metref = document.getElementById(id)
        if (metref) {
            metref.innerHTML = isPass ? RESULT.pass : RESULT.fail
        }


    }
    const resultNave = (assignment, question_no, standard) => ({
        items: map(RESULT, (flg, i) => ({
            key: i,
            label: (
                <MenuItem>
                    {flg}
                </MenuItem>
            ),
            onClick: () => {
                onMetChange(i == "pass", assignment, question_no, standard);
                onchangeIcon(assignment.id + "met_icon" + question_no, i == "pass")
            }
        }))
    });
    const MetCellRender = (p) => {
        const value = p.value;
        if(typeof value !== "object"|| Object.keys(value).length==0) return <></>
        const { isCorrect , assignment , isOpenEnded , question_no  , standard , answer , hasSubmissions  , hasAnswered } = value
        const result_icon = hasSubmissions && hasAnswered ? (isCorrect?RESULT.pass:RESULT.fail):'-'
        const hasMet =  find(answer?.met,["standard",standard]);
        const isMet = get(hasMet,"met")
        const met_icon = Boolean(isMet)?RESULT.pass:RESULT.fail
        return (
            <div className="quesTxtIcon">
                {!isOpenEnded ? result_icon : <Dropdown disabled={!hasSubmissions} menu={resultNave(assignment, question_no, standard)}
                    placement="bottomLeft" trigger={['click']}
                >
                    {hasSubmissions ? <span> <span id={assignment.id + "met_icon" + question_no}>{hasMet ? met_icon : "⚪️"} </span> <CaretDownOutlined style={{ fontSize: '10px', marginLeft: '6px' }} /></span> : <span>-</span>}
                </Dropdown>}
            </div>
        )
    }
    const [assignmentColDefs] = useState([
        { field: 'Question', width: 118, headerComponent: QuestionHeader },
        { field: 'Standard', width: 260, cellRenderer: StandardCellRender, },
        { field: 'Met/Fail', width: 90, cellRenderer: MetCellRender },
        { field: 'Level/Assigned', width: 140 },
        { field: 'Average per question', width: 180 },
    ])

    const [assignmentOverAllRowData, setAssignmentOverAllRowData] = useState([

    ]);
    const [assignmentOverAllColDefs] = useState([
        { field: 'Standard', width: 230, cellRenderer: StandardCellRender, },
        { field: 'Met', width: 90 },
        { field: 'Fail', width: 90 },
        { field: 'Basico', width: 110 },
        { field: 'Intermedio', width: 110 },
        { field: 'Avanzado', width: 110 },
    ])

    const listCurrentClassInfo = async () => {
        if (get(currentClass, "id")) {
            dispatch(handleListClassUsers(get(currentClass, "id")));
            dispatch(handleListClassActivities(get(currentClass, "id")));
            dispatch(handleListClassQuizzes(get(currentClass, "id")));
            dispatch(handleListClassSubmissions(get(currentClass, "id")))
        }
    }
    const listAllAssignments = async () => {
        return;
        if (!Array.isArray(activities) || activities.length == 0) {
            await dispatch(handleListActivities());
        }

        if (!Array.isArray(quizzes) || quizzes.length == 0) {
            await dispatch(handleListQuizzes());
        }
        await dispatch(handleListCustomAssignment(get(currentUser, "role"), get(currentUser, "id")))
    }

    const fetchApis = async () => {
        setDataloading(true)
        await Promise.allSettled([
            listCurrentClassInfo(),
            listAllAssignments()
        ])
        setDataloading(false)
    }
    useEffect(() => {
        fetchApis()
    }, [])

    useEffect(() => {
        const allstudents = uniqBy(filter(classUsers, x => x.role === 'student').sort(sortname), "username");
        const viewStudents = allstudents.filter((u) =>
            studentMatchesGradebookActiveFilter(u, activeInactive)
        );
        setListStudentUser(viewStudents);
        setFilteredStudent(viewStudents);
    }, [classUsers, activeInactive])


    const handleGradeValueShow = (assignment, subData) => {
        const orderedSemDt = [...classActivityData, ...classQuizzesData]
        const groupedSubmission = subData ? subData : studentSubmissions
        const questions = get(assignment, "data.questions", [])
        const level = get(assignment, "data.level", "")
        const user = get(assignment, "user", {})
        const subm = find(groupedSubmission[user.id], ['assignmentId', get(assignment, "data.id")]);
        const smAnswer = get(subm, "answers", [])
        const rowData = []
        const standard = {
        }
        map(orderedSemDt, smDt => {
            const subm = find(groupedSubmission[user.id], ['assignmentId', get(smDt, "data.id")]);
            const smAnswer = get(subm, "answers", [])
            map(get(smDt, "data.questions", []), (q, i) => {
                const ans = smAnswer[i];
                const isCorrect = get(ans, "answer") == get(q, "answer");
                const stateStandardRaw = q.state_standard && Array.isArray(q.state_standard) ? q.state_standard : [];
                const stateStandard = filterStateStandardByEnabledStates(stateStandardRaw, enabledStateCodes);
                const std = q.standard || '';
                
                let allStd = [];
                if (stateStandard.length > 0) {
                    stateStandard.forEach((stateStd) => {
                        if (stateStd && Array.isArray(stateStd.standard)) {
                            allStd.push(...stateStd.standard);
                        }
                    });
                } else if (std) {
                    allStd = std.split(",").filter(k => k);
                }
                
                map(allStd, st => {
                    if (standard[st]) {
                        const prevAn = standard[st];
                        standard[st] = {
                            correct: isCorrect ? prevAn.correct + 1 : prevAn.correct,
                            total: prevAn.total + 1
                        }
                    } else {
                        standard[st] = {
                            correct: isCorrect ? 1 : 0,
                            total: 1
                        }
                    }
                })

            })
        });

        if (questions.length > 0) {
            map(questions, function (value, key) {
                const isCorrect = get(smAnswer[key], "answer") == get(value, "answer")
                const stateStandardRaw = get(value, "state_standard", []);
                const stateStandard = filterStateStandardByEnabledStates(stateStandardRaw, enabledStateCodes);
                const standed = get(value, "standard", '');
                
                let standardsToProcess = [];
                
                if (stateStandard && Array.isArray(stateStandard) && stateStandard.length > 0) {
                    stateStandard.forEach((stateStd) => {
                        if (stateStd && Array.isArray(stateStd.standard)) {
                            standardsToProcess.push(...stateStd.standard);
                        }
                    });
                } else if (standed) {
                    standardsToProcess = standed.split(",").filter(k => k);
                }
                
                if (standardsToProcess.length > 0) {
                    const allStandardsString = standardsToProcess.join(', ');
                    const firstStandard = standardsToProcess[0];
                    const st = standard[firstStandard];
                    const stdString = st ? `${st.correct} out of ${st.total}` : '';
                    
                    rowData.push({ 
                        'Question': key + 1, 
                        Standard: allStandardsString, 
                        question: value,
                        'Met/Fail': { 
                            isCorrect, 
                            assignment, 
                            isOpenEnded: value.type !== 'multipleChoice',
                            standard: firstStandard, 
                            question_no: key, 
                            answer: smAnswer[key], 
                            hasSubmissions: !!subm, 
                            hasAnswered: smAnswer[key]
                        }, 
                        'Level/Assigned': level, 
                        'Average per question': stdString 
                    });
                }
            })
        }
        if (rowData.length < 10) {
            let len = 10 - rowData.length;
            let arr = new Array(len).fill({ 'Question': null, Standard: '', 'Met/Fail': {}, 'Level/Assigned': '', 'Average per question': '' }, 0, len)
            rowData.push(...arr)
        }
        setAssignmentRowData(rowData)
        setDataShow(true);
    };
    const handleoverAllShow = (user) => {
        const orderedSemDt = [...classActivityData, ...classQuizzesData];
        const standard = {};

        for (const smDt of orderedSemDt) {
            const subm = studentSubmissions[user.id]?.find(s => s.assignmentId === smDt.data.id);
            const smAnswer = subm?.answers || [];
            const questions = smDt.data.questions || [];

            questions.forEach((q, i) => {
                let isCorrect = false;
                const ans = smAnswer[i];
                const stateStandardRaw = q.state_standard && Array.isArray(q.state_standard) ? q.state_standard : [];
                const stateStandard = filterStateStandardByEnabledStates(stateStandardRaw, enabledStateCodes);
                const standed = q.standard || '';
                
                let allStd = [];
                if (stateStandard.length > 0) {
                    stateStandard.forEach((stateStd) => {
                        if (stateStd && Array.isArray(stateStd.standard)) {
                            allStd.push(...stateStd.standard);
                        }
                    });
                } else if (standed) {
                    allStd = standed.split(",").filter(k => k);
                }

                for (const st of allStd) {
                    isCorrect =  q.type !== 'multipleChoice'
                    ? ans?.met?.some(m => m.standard === st && m.met)
                    :  `${ans?.answer}` === `${q.answer}`;
                    const level = smDt.data.level || "";
                    const isOpenEnded = q.type !== 'multipleChoice';
                    const isGradedForOpenEnded =  ans?.met?.some(m => m.standard === st);
                    let total_to_add =  isOpenEnded ? (isGradedForOpenEnded ? 1 :0):1;
                    if (standard[st]) {
                        standard[st].hasSubmissions = standard[st].hasSubmissions || !!subm;
                        standard[st].correct +=  isCorrect ? 1 : 0;
                        standard[st].total +=  total_to_add;
                        standard[st][level] += 1;
                    } else {
                        standard[st] = {
                            hasSubmissions: !!subm,
                            correct: isCorrect ? 1 : 0,
                            total:  total_to_add,
                            BASICO: level === "BASICO" ? 1 : 0,
                            INTERMEDIO: level === "INTERMEDIO" ? 1 : 0,
                            AVANZADO: level === "AVANZADO" ? 1 : 0
                        };
                    }
                }
            });
        }

        const rowData = Object.entries(standard).map(([key, val]) => {
            const metPercent = Math.round((val.correct / Math.max(val.total, 1)) * 100);
            return {
                Standard: key,
                Met: val.hasSubmissions ? `${metPercent}%` : '-',
                Fail: val.hasSubmissions ? `${100 - metPercent}%` : '-',
                Basico: val.BASICO,
                Intermedio: val.INTERMEDIO,
                Avanzado: val.AVANZADO
            };
        });

        // Fill up rowData to ensure at least 10 entries
        while (rowData.length < 10) {
            rowData.push({ Standard: null, Met: '', Fail: '', Basico: null, Intermedio: null, Avanzado: null });
        }

        setAssignmentOverAllRowData(rowData);
        setDataShow2(true);
    };

    const updateAssignmentToSchoology = async (quizeDataforCreate) => {
        let sectionId = currentClass.sectionId;
        if (currentUser.schoologyid && sectionId) {
            let data = {
                "title": quizeDataforCreate.displayName,
                "due": `${quizeDataforCreate.dueDate}`,
                "grading_category": quizeDataforCreate.schoologyCategory
            }
            return  dispatch(handleUpdateSchoologyAssignment(sectionId,currentUser.id,data, quizeDataforCreate.sAssignmentId));
        }
        return null
    }
    const calculateValue = (assignment, user) => {
        if (!user || !get(assignment, "data")) return ({ value: "-", submission: {} })
        const subm = find(studentSubmissions[user.id], ['assignmentId', get(assignment, "data.id")]);
        const value = (subm && subm.grade >= 0 ? subm.grade : '-')
        return { value, submission: subm }
    };
    useEffect(() => {
        const orderedSemDt = [...classActivityData, ...classQuizzesData]
        if (orderedSemDt.length < 8) {
            let len = 8 - orderedSemDt.length;
            let arr = new Array(len).fill({}, 0, len)
            orderedSemDt.push(...arr)
        }
        const colsDt = [
            {
                headerName: "Name of story:",
                children: [
                    {
                        headerName: "Page Number:",
                        children: [{
                            headerName: "Date:",
                            cellRenderer: stickyCellRenderer,
                            width: 210,
                            field: "user",
                            pinned: 'left',
                        }],
                    },
                ],
            },
        ]


        map(orderedSemDt, smDt => {
            colsDt.push(
                {
                    headerName: get(smDt, "displayName"),
                    field: get(smDt, "id"),
                    children: [
                        {
                            headerName: getAssignmentLable(smDt, booksAllList, videos, resources),
                            children: [{
                                headerName: get(smDt, "dueDate") ? moment(get(smDt, "dueDate")).format("MMM DD") : '',
                                field: get(smDt, "id"),
                                headerClass: "story-ag-cell-value",
                                cellRenderer: modelCellRenderer,
                                refData: smDt,
                            }],
                        },
                    ],
                })
        })
        const listUser = filteredStudent;
        const rows = map(listUser, k => {
            const res = { user: { ...k } }
            map(orderedSemDt, smDt => {
                const submissionData = calculateValue(smDt, k)
                if (get(smDt, "id")) {
                    res[get(smDt, "id")] = {
                        ...smDt,
                        user: k,
                        submissionData
                    }
                } else {
                    res['-'] = {
                        user: k,
                        submissionData
                    }
                }

            });
            return res;
        })
        const numberOfQuestionByAssignment = {}
        map(orderedSemDt, smDt => {
            if (get(smDt, "id")) {
                numberOfQuestionByAssignment[get(smDt, "id")] = {
                    numberOfQuestion: get(smDt, "data.questions.length", 0),
                }
            } else {
                numberOfQuestionByAssignment['-'] = '-'
            }
        });
        rows.unshift(numberOfQuestionByAssignment)
        setRowData(rows)
        setColsDefs(colsDt)
    }, [filteredStudent, submissions, classActivities, classQuizzes])
    const onSearchStudent = (e) => {
        let text = e.target.value;
        setSearchInput(text);
        if (typeof text === "string" && text.length > 0) {
            text = text.toLowerCase()
            const ftStudent = filter(listStudentUser, st => {
                if (st) {
                    const firstName = st.firstName ? st.firstName : '';
                    const lastName = st.lastName ? st.lastName : '';
                    if (firstName.toLowerCase().includes(text) || lastName.toLowerCase().includes(text)) {
                        return true;
                    }
                }
                return false;
            })
            setFilteredStudent(ftStudent)
        } else {
            setFilteredStudent(listStudentUser)
        }
    }
    const getAssignmentCreation = (assignmentdata, userdata) => {
        try {
            let _assignmentinfo = assignmentdata.data ?? {};
            let quizdata = {
                answers: [],
                assignment: _assignmentinfo,
                assignmentId: _assignmentinfo.id,
                assignmentType: _assignmentinfo.typeId,
                chapter: _assignmentinfo.chapter,
                classId: currentClass.id,
                complete: false,
                createdAt: Date.now(),
                feedback: '',
                grade: null,
                face_grade: null,
                graded: true,
                isLate: false,
                orgId: currentOrg?.id,
                retakes: assignmentdata.retakes,
                retaking: false,
                submissions: 0,
                timmer: 0,
                user: userdata,
                userId: userdata.id,
                bookId: _assignmentinfo.bookId,
                isTemp: true
            }
            return quizdata;
        } catch (error) {
            Sentry.captureException(`370 Error during getAssignmentCreation: ${error}`);
            return {};
        }
    }
    const reviewAssignment = (data, tempData, users, userSubmissions) => {
        const _assignment = [...classActivityData, ...classQuizzesData].filter(a => (a.quizId === data?.assignmentId || a.activityId === data?.assignmentId))[0];
        let sAssignmentId = get(data, "sAssignmentId");
        if (_assignment && _assignment.sAssignmentId) {
            sAssignmentId = _assignment.sAssignmentId;
        }
        if (data) {
            data.sAssignmentId = sAssignmentId;
        }
        if (!data) {
            const utemp = cloneDeep(tempData);
            utemp.isTemp = true;
            data = utemp;
            data.sAssignmentId = sAssignmentId;
        }
        const userdata = map(users, usr => {
            const sub = userSubmissions[usr.id]
            if (sub) {
                const asub = find(sub, n => get(n, "assignmentId") == get(data, "assignmentId", get(tempData, "assignmentId")))
                if (asub) {
                    asub.sAssignmentId = sAssignmentId;
                    return asub
                } else {
                    const utemp = cloneDeep(tempData);
                    utemp.userId = usr.id;
                    utemp.user = usr;
                    utemp.isTemp = true;
                    utemp.sAssignmentId = sAssignmentId;
                    return utemp;
                }
            } else {
                const utemp = cloneDeep(tempData);
                utemp.userId = usr.id;
                utemp.user = usr;
                utemp.isTemp = true;
                utemp.sAssignmentId = sAssignmentId;
                return utemp;
            }
        })
        setSelectedAssignmentSubmissions(userdata)
        setAssignmentData(data);
        toggleAssignmentDrawer(true);
    };
    const openEditActivity = (activity) => {
        if (activity.timeDuration > 0) {
            setDurationSection(true)
        }
        setActivityData({
            editing: true,
            ...activity
        });
        toggleActivityDrawer(true);
    }
    const openEditQuiz = (quiz) => {
        if (quiz.timeDuration > 0) {
            setDurationSection(true)
        }
        setQuizData({
            editing: true,
            ...quiz
        });
        toggleQuizDrawer(true);
    }
    const updateActivityData = (id, value) => {
        const val = value&&value.length > 1 && value[0] === '0' ? value.replace('0', '') : value;
        setActivityData(prevState => ({
            ...prevState,
            [id]: val
        }));
    };
    const updateActivity = async (e) => {
        e.preventDefault();
        if (activityData && activityData.sAssignmentId && currentClass.sectionId) {
            if (activityData.sAssignmentId && currentClass.sectionId) {
                let u = await updateAssignmentToSchoology(activityData)
            }
        }
        setLoading(true);
        await dispatch(handleUpdateClassActivity(
            activityData.id,
            {
                ...activityData,
                retakes:  typeof activityData.retakes =="string" ? activityData.retakes.trim(): activityData.retakes,
                dueDate: activityData.dueDate,
                lateDate: activityData.lateDate,
                timeDuration: activityData.timeDuration,
                classes: activityData.classes,
                weightage: activityData.weightage,
                displayName: activityData.displayName,
                classId: activityData.classId,
                rubrics_id:  fetchSelectedRubric
            },
            activityData.updateTOAllClass
        ));
        await dispatch(handleListClassActivities(currentClass.id));
        toggleActivityDrawer(false);
        setLoading(false);
        setActivityData({});
        setDurationSection(false)
    };
    const updateQuiz = async (e) => {
        e.preventDefault();
        setLoading(true);
        if (quizData.sAssignmentId && currentClass.sectionId) {
            let u = await updateAssignmentToSchoology(quizData)
        }
        await dispatch(handleUpdateClassQuiz(
            quizData.id,
            {
                ...quizData,
                retakes:  typeof quizData.retakes =="string" ? quizData.retakes.trim(): quizData.retakes,
                dueDate: quizData.dueDate,
                lateDate: quizData.lateDate,
                timeDuration: quizData.timeDuration || 0,
                classes: quizData.classes,
                weightage: quizData.weightage,
                displayName: quizData.displayName,
                scheduleAt: quizData.scheduleAt,
                classId: quizData.classId,
                rubrics_id:  fetchSelectedRubric
            },
            quizData.updateTOAllClass
        ));
        await dispatch(handleListClassQuizzes(currentClass.id));
        toggleQuizDrawer(false);
        setLoading(false)
        setQuizData({});
        setDurationSection(false)
    };
    const updateQuizData = (id, value) => {
        const val = value&&value.length > 1 && value[0] === '0' ? value.replace('0', '') : value;
        setQuizData(prevState => ({
            ...prevState,
            [id]: val
        }));
    };

    const orderNav = () => ({
        items: ORDER_BY.map((item) => ({
            key: item.key,
            label: (
                <PaddedBtn onClick={() => {
                    setDatePrefrences(item.key)
                    handleUpdateDatePref(item.key)
                }}>
                    {item.value}
                </PaddedBtn>
            ),
            style: { padding: '0px' }
        }))
    });
  
    const orderByAscOrDes = () => ({
        items: ORDER_BY_Filter.map((item) => ({
            key: item.key,
            label: (
                <PaddedBtn onClick={() => {
                    setOrderByDate(item.key)
                    handleUpdateorderByPref(item.key)
                }}>
                    {item.value}
                </PaddedBtn>
            ),
            style: { padding: '0px' }
        }))
    });

    const activeInactiveNav = () => {
        return {
            items: [
                { key: 'active', label: 'Active' , onClick: () => {
                    setActiveInactive('active')
                }},
                { key: 'inactive', label: 'Inactive' , onClick: () => {
                    setActiveInactive('inactive')
                }}
            ]
        }
    }

 

    const handleUpdateorderByPref = async (_orderBy) => {
        setUpdateOrderByLoader(true)
        if (currentUser) {
            if (!userPreference || typeof userPreference == "object" && Object.keys(userPreference).length == 0) {
                await dispatch(handleCreateUserPreference(currentUser.id, { orderBy: _orderBy }))
            } else {
                await dispatch(handleUpdateUserPreference(currentUser.id, { orderBy: _orderBy }))
            }
        }
        setUpdateOrderByLoader(false)
    }

    const handleUpdateDatePref = async (order_by_date) => {
        setUpdateDateLoader(true)
        if (currentUser) {
            if (!userPreference || typeof userPreference == "object" && Object.keys(userPreference).length == 0) {
                await dispatch(handleCreateUserPreference(currentUser.id, { order_by_date }))
            } else {
                await dispatch(handleUpdateUserPreference(currentUser.id, { order_by_date }))
            }
            setOpen(true);
            setPopupMessage(`This change will be automatically updated to all the classes`)
        }
        setUpdateDateLoader(false)
    }

    const handleUpdateGradePref = async (_scale) => {
        setUpdatePrefLoader(true)
        if (currentUser) {
            if (!userPreference || typeof userPreference == "object" && Object.keys(userPreference).length == 0) {
                await dispatch(handleCreateUserPreference(currentUser.id, { gradePref: _scale }))
            } else {
                await dispatch(handleUpdateUserPreference(currentUser.id, { gradePref: _scale }))
            }
        }
        setUpdatePrefLoader(false)
    }

    const gradeNav = () => {
        return {
            items: GRADE_PREF.map((item) => ({
                key: item.key,
                label: (
                    <PaddedBtn onClick={() => {
                        handleUpdateGradePref(item.key)
                    }}>
                        {item.value}
                    </PaddedBtn>
                ),
                style: { padding: '0px' }
            }))
        };
    };

    const buildDownloadRows = useCallback(() => {
        const formatGradeForDownload = (rawValue) => {
            if (rawValue === null || rawValue === undefined) return '-';
            if (rawValue === '-') return '-';
            if (rawValue === '') return '';

            const numeric = typeof rawValue === 'number' ? rawValue : Number(rawValue);
            if (Number.isNaN(numeric)) {
                return String(rawValue);
            }

            if (scale_1_5) {
                const g = numeric <= 0 ? 0 : Math.floor((numeric - 1) / 20);
                return String(g > 4 ? 4 : g);
            }

            if (gradebook_a_f) {
                return af_grade(numeric);
            }

            return String(rawValue);
        };

        const uniqueActivity = uniqBy(classActivityData, 'activityId');
        const uniqueQuiz = uniqBy(classQuizzesData, 'quizId');
        const mergedAssignments = [...uniqueActivity, ...uniqueQuiz];
        const realAssignments = filter(mergedAssignments, (k) => get(k, 'data.id'));
        const pref = userPreference || {};
        const dateMode = pref.order_by_date || datePrefrences || 'due_date';
        const sortDir =
            pref.orderBy === 'asc' || pref.orderBy === 'desc'
                ? pref.orderBy
                : orderByFilter === 'asc' || orderByFilter === 'desc'
                  ? orderByFilter
                  : 'desc';
        const dueOf = (a) => get(a, 'dueDate') ?? get(a, 'data.dueDate');
        const lateOf = (a) => get(a, 'lateDate') ?? get(a, 'data.lateDate');
        const schedOf = (a) => get(a, 'scheduleAt') ?? get(a, 'data.scheduleAt');
        let orderedSemDt;
        if (dateMode === 'due_date') {
            const hasDue = (k) => Boolean(dueOf(k));
            orderedSemDt = [
                ...orderBy(filter(realAssignments, hasDue), [(item) => new Date(dueOf(item))], [sortDir]),
                ...filter(realAssignments, (k) => !hasDue(k)),
            ];
        } else if (dateMode === 'late_submission') {
            const hasLateOrDue = (k) => Boolean(lateOf(k) || dueOf(k));
            orderedSemDt = [
                ...orderBy(
                    filter(realAssignments, hasLateOrDue),
                    [(item) => new Date(lateOf(item) || dueOf(item))],
                    [sortDir],
                ),
                ...filter(realAssignments, (k) => !lateOf(k) && !dueOf(k)),
            ];
        } else {
            const hasSched = (k) => Boolean(schedOf(k));
            orderedSemDt = [
                ...orderBy(filter(realAssignments, hasSched), [(item) => new Date(schedOf(item))], [sortDir]),
                ...filter(realAssignments, (k) => !hasSched(k)),
            ];
        }
        const headers = ['Name', 'Username', 'Student Id'];
        orderedSemDt.forEach((smDt) => {
            headers.push(get(smDt, 'displayName', '') || '-');
        });

        const rows = [headers];

        const questionsRow = ['Number of Questions', '', ''];
        orderedSemDt.forEach((smDt) => {
            questionsRow.push(get(smDt, 'data.questions.length', 0));
        });
        rows.push(questionsRow);

        (filteredStudent || []).forEach((user) => {
            const row = [
                `${get(user, 'lastName', '')}, ${get(user, 'firstName', '')}`,
                get(user, 'username', ''),
                get(user, 'studentId', '')
            ];
            orderedSemDt.forEach((smDt) => {
                const { value } = calculateValue(smDt, user);
                row.push(formatGradeForDownload(value));
            });
            rows.push(row);
        });

        return { rows, headers };
    }, [
        filteredStudent,
        classActivityData,
        classQuizzesData,
        studentSubmissions,
        scale_1_5,
        gradebook_a_f,
        userPreference,
        datePrefrences,
        orderByFilter,
    ]);

    const recordDownload = useCallback((fileName) => {
        try {
            if (currentClass?.id && currentUser?.id) {
                dispatch(handleCreateDownloadList({
                    title: fileName,
                    url: fileName,
                    class_id: currentClass.id,
                    created_by: currentUser.id
                }));
            }
        } catch (error) {
            Sentry.captureException(`Error logging story gradebook download: ${error}`);
        }
    }, [currentClass, currentUser, dispatch]);

    const generateCSV = useCallback(async () => {
        try {
            const { rows } = buildDownloadRows();
            const toCsvCell = (value) => {
                if (value === null || value === undefined) return '';
                const text = String(value).replace(/"/g, '""');
                if (/[",\n]/.test(text)) {
                    return `"${text}"`;
                }
                return text;
            };
            const csvContent = rows.map((row) => row.map(toCsvCell).join(',')).join('\n');
            const { saveAs } = await import('file-saver');
            const fileName = `story_gradebook ${dayjs().format('DD-MM-YY hh:mm:ss')}.csv`;
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            saveAs(blob, fileName);
            recordDownload(fileName);
        } catch (error) {
            Sentry.captureException(`Error in story gradebook CSV download: ${error}`);
        }
    }, [buildDownloadRows, recordDownload]);

    const generateXLSX = useCallback(async () => {
        try {
            const { rows, headers } = buildDownloadRows();
            const ExcelJS = (await import('exceljs')).default;
            const { saveAs } = await import('file-saver');
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Story Gradebook');
            const columnCount = headers.length;
            worksheet.columns = Array.from({ length: columnCount }, () => ({ width: 22 }));
            worksheet.addRows(rows);

            const borderColor = 'FF000000';
            const borderStyle = 'thin';
            const headerFill = 'FFD9EAD3';
            const subHeaderFill = 'FFD9EAF7';
            const oddFill = 'FFFFFFFF';
            const evenFill = 'FFF5F5F5';

            for (let rowIndex = 1; rowIndex <= rows.length; rowIndex++) {
                const row = worksheet.getRow(rowIndex);
                const isHeader = rowIndex === 1;
                const isQuestionsRow = rowIndex === 2;
                const fillColor = isHeader
                    ? headerFill
                    : isQuestionsRow
                        ? subHeaderFill
                        : (rowIndex - 3) % 2 === 0
                            ? oddFill
                            : evenFill;
                if (isHeader || isQuestionsRow) {
                    row.height = 32;
                }
                for (let colIndex = 1; colIndex <= columnCount; colIndex++) {
                    const cell = row.getCell(colIndex);
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: fillColor }
                    };
                    cell.border = {
                        top: { style: borderStyle, color: { argb: borderColor } },
                        bottom: { style: borderStyle, color: { argb: borderColor } },
                        left: { style: borderStyle, color: { argb: borderColor } },
                        right: { style: borderStyle, color: { argb: borderColor } }
                    };
                    cell.alignment = {
                        vertical: 'middle',
                        horizontal: 'center',
                        wrapText: true
                    };
                    if (isHeader || isQuestionsRow) {
                        cell.font = { bold: true };
                    }
                }
            }

            const fileName = `story_gradebook ${dayjs().format('DD-MM-YY hh:mm:ss')}.xlsx`;
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, fileName);
            recordDownload(fileName);
        } catch (error) {
            Sentry.captureException(`Error in story gradebook XLSX download: ${error}`);
        }
    }, [buildDownloadRows, recordDownload]);

    const downloadNav = useCallback(() => ({
        items: [
            {
                key: 'XLSX',
                label: <PaddedBtn onClick={() => generateXLSX()}>XLSX</PaddedBtn>,
                style: { padding: '0px' }
            },
            {
                key: 'CSV',
                label: <PaddedBtn onClick={() => generateCSV()}>CSV</PaddedBtn>,
                style: { padding: '0px' }
            }
        ]
    }), [generateXLSX, generateCSV]);

    const handleClose = () => {
        setOpen(false);
    };

    return (<>
    <SpinLoader dataloader={storyNavPrefetchLoading} />
    <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={openPop}
                autoHideDuration={5000}
                onClose={handleClose}>
                <Alert onClose={handleClose} severity="info">
                    <strong>ALERT:</strong> {popupMessage}
                </Alert>
            </Snackbar>
     <Drawer
                height='100%'
                destroyOnHidden
                className='assignments-drawer assignments-drawerCstm'
                onClose={() => {
                    toggleActivityDrawer(false);
                    setActivityData({});
                    setDurationSection(false)
                }}
                placement='top'
                open={activityDrawer}
                key='activityNew'
            >
                <>
                    <SentryWrap>
                        <ActivityForm
                            data={activityData}
                            handleChange={e => updateActivityData(e.target.id, e.target.value)}
                            handleSubmit={activityData.editing ? updateActivity :()=>{}}
                            setDurationSection={setDurationSection}
                            durationSection={durationSection}
                            loading={loading}
                            onClose={() => toggleActivityDrawer(false)}
                            handleRubric={(value)=> {
                                setFetchRubricId(value?.id || "")
                              }}
                        />
                    </SentryWrap>
                </>
            </Drawer>
            <Drawer
                destroyOnHidden
                height='100%'
                className='assignments-drawer assignments-drawerCstm'
                onClose={() => {
                    toggleQuizDrawer(false);
                    setQuizData({});
                    setDurationSection(false)
                }}
                placement='top'
                open={quizDrawer}
                key='quizNew'
            >
                
                    <SentryWrap>
                        <QuizForm
                            data={quizData}
                            handleChange={e => updateQuizData(e.target.id, e.target.value)}
                            handleSubmit={quizData.editing ? updateQuiz : ()=>{}}
                            setDurationSection={setDurationSection}
                            durationSection={durationSection}
                            loading={loading}
                            onClose={() => toggleQuizDrawer(false)}
                        />
                    </SentryWrap>
               
            </Drawer>
        <Drawer
            height='100%'
            destroyOnHidden
            onClose={() => {
                toggleAssignmentDrawer(false);
                setAssignmentData({});
                setSelectedAssignmentSubmissions([])
            }}
            placement='top'
            open={assignmentDrawer}
            key='assignmentNew'
            className='student-review-new'
        >
          {assignmentDrawer ? (
            <Suspense fallback={<Loading />}>
              <AssignmentReview
                open={assignmentDrawer}
                booksAllList={booksAllList}
                data={assignmentData}
                usersSubmissionData={selectedAssignmentUserSubmission}
                currentClass={currentClass}
                handleClose={() => {
                    setLoading(true)
                    toggleAssignmentDrawer(false)
                    setLoading(false)
                }}
                scale_1_5={userPreference?.gradePref == "scale_1_5"}
                gradebook_a_f={userPreference?.gradePref === "gradebook_a_f"}
                showAlert={showAlert}
              />
            </Suspense>
          ) : null}
        </Drawer>
        <Modal
            open={labelDescriptionView.open}
            onClose={() => setLabelDescriptionView({ open: false, describe: "" })}
        ><ModalContent>
                <MessageContgainer>
                    {labelDescriptionView.describe}
                </MessageContgainer>
            </ModalContent>
        </Modal>
        <StandardsModal
            open={standardsModal.open}
            onClose={() => setStandardsModal({ open: false, standardAbbrs: [], stateStandard: null })}
            standardAbbrs={standardsModal.standardAbbrs}
            stateStandard={standardsModal.stateStandard}
            standards={standards}
            enabledStateCodes={enabledStateCodes}
        />
        <div className="dataSectionBg">
            <div className="container">
                <Row>
                    <Col xs={24} sm={24} md={24} lg={24}>
                        <div className="dataHead">
                            <div className="dataHeadLogo"><img src={datagrid_logoColored} title="One Way Assessments" alt="" /></div>
                        </div>
                        <Row className="dataOverRow" gutter={[32, 0]}>
                            <Col xs={24} sm={18} md={18} lg={17}>
                                <div className="numStudent" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'nowrap', gap: '16px' }}>
                                    <div>
                                        <label>Overview</label>
                                        <p style={{ margin: 0, whiteSpace: 'nowrap' }}>Total Number of Students: {listStudentUser?.length ?? 0}</p>
                                    </div>
                                    <Dropdown menu={activeInactiveNav()} placement="bottomLeft" trigger={['click']} >
                                        <StudentStatusSelector onClick={(e) => {
                                            e.preventDefault()
                                        }}>
                                            <span>{typeof activeInactive === 'string' ? activeInactive.charAt(0).toUpperCase() + activeInactive.slice(1) : 'Active'} students</span>
                                            <CaretDownOutlined style={{ fontSize: '12px', marginLeft: '8px', transition: 'transform 0.2s ease' }} />
                                        </StudentStatusSelector>
                                    </Dropdown>
                                </div>
                            </Col>
                            <Col xs={24} sm={6} md={6} lg={7} className='allFindStudent'>
                                <div className="findStudent">
                                    <Search type="text" value={searchInput} onChange={onSearchStudent} placeholder="Find your student" />
                                    <img src={datagrid_searchIcon} title="" alt="" />
                                </div>
                            </Col>
                            <div className="clearFindStdnt"></div>
                        </Row>
                        <div className='w-full flex items-center justify-end mb-10 flex-wrap sm-gap-10px newGridViewDropDown gap-10px'>
                        <Dropdown menu={orderNav()} placement="bottomLeft" trigger={['click']}>
                                <Button className='viewByBtn sm-w-full sm-mr-0' style={{ display:"flex",background: "#765e9e", color:"white", flexDirection: "row", alignItems: "center" }}
                                    disabled={updateDateLoader}
                                    onClick={(e) => {
                                        e.preventDefault()
                                    }}>
                                    <InfoCircleOutlined style={{ marginRight: '4px' }} />
                                    {updateDateLoader && <Loading white={true}  style={{marginRight: "5px"}} size={15} />}
                                    View By ({selectedLabel})<DownOutlined style={{ marginLeft:"8px", fontSize:"15px" }} />
                                </Button>
                            </Dropdown>
                            <Dropdown menu={orderByAscOrDes()} placement="bottomLeft" trigger={['click']}>
                                    <Button className='sm-w-full sm-mr-0' style={{ display: "flex", flexDirection: "row", alignItems: "center",background: "#765e9e", color:"white" }}
                                        disabled={updateOrderByLoader}
                                        onClick={(e) => {
                                            e.preventDefault()
                                        }} >
                                        <InfoCircleOutlined style={{ marginRight: '4px' }} />
                                        {updateOrderByLoader && <Loading white={true} style={{marginRight: "5px"}} size={15} />}
                                        Order By date ({selectedOrderLabel}) <DownOutlined style={{ marginLeft:"8px", fontSize:"15px" }} />
                                    </Button>
                                </Dropdown>
                            <Dropdown menu={gradeNav()} placement="bottomLeft" trigger={['click']}>
                                <Button className='sm-w-full sm-mr-0' style={{ display: "flex", flexDirection: "row", alignItems: "center", background: "#765e9e", color:"white" }}
                                    disabled={updatePrefLoader}
                                    onClick={(e) => {
                                        e.preventDefault()
                                    }} >
                                    <InfoCircleOutlined style={{ marginRight: '4px' }} />
                                    {updatePrefLoader && <Loading white={true} style={{marginRight: "5px"}} size={15} />}
                                    {scale_1_5 ? GRADE_PREF[1].value : gradebook_a_f ? GRADE_PREF[2].value : GRADE_PREF[0].value}
                                    <DownOutlined style={{ marginLeft:"8px", fontSize:"15px" }} />
                                </Button>
                            </Dropdown>
                            <Dropdown menu={downloadNav()} placement="bottomRight" trigger={['click']}>
                                <Button className='sm-w-full sm-mr-0' style={{ display: "flex", flexDirection: "row", alignItems: "center", background: "#765e9e", color: "white" }}
                                    onClick={(e) => {
                                        e.preventDefault()
                                    }} >
                                    <DownloadOutlined style={{ marginRight: '6px' }} />
                                        Download
                                    <DownOutlined style={{ marginLeft: "8px", fontSize: "15px" }} />
                                </Button>
                            </Dropdown>
                        </div>
                        <div className="dataColloect">
                            {/* Start of Model 1 */}
                            <div className="eyeDataUpr">
                                <Modal className="eyeDataMdl" open={DataShow2} onClose={() => setDataShow2(false)}>
                                    <ModalContent>
                                        <div className="ag-theme-alpine eyeDataInr">
                                            <a className="closeEyeData" onClick={() => setDataShow2(false)}><img src={datagrid_close} title="" alt="" /></a>
                                            <Suspense fallback={<Loading />}>
                                                <AgGridReact
                                                    rowData={assignmentOverAllRowData}
                                                    columnDefs={assignmentOverAllColDefs}
                                                    className="eyeDataTable2"
                                                    columnHoverHighlight={true}>
                                                </AgGridReact>
                                            </Suspense>
                                        </div>
                                    </ModalContent>
                                </Modal>
                            </div>
                            {/* End of Model 1 */}

                            {/* Start of Model 2  Inner Table Model */}
                            <div className="eyeDataUpr">
                                <Modal className="eyeDataMdl" open={DataShow} onClose={() => setDataShow(false)}>
                                    <ModalContent>
                                        <div className="ag-theme-alpine eyeDataInr">
                                            <a className="closeEyeData" onClick={() => setDataShow(false)}><img src={datagrid_close} title="" alt="" /></a>
                                            <Suspense fallback={<Loading />}>
                                                <AgGridReact
                                                    rowData={assignmentRowData}
                                                    columnDefs={assignmentColDefs}
                                                    className="eyeDataTable"
                                                    columnHoverHighlight={true}>
                                                </AgGridReact>
                                            </Suspense>
                                        </div>
                                    </ModalContent>
                                </Modal>
                            </div>
                            {/* End of Model 2 */}

                            {/* Start of Data Table  */}
                            <Row className="storyDataWrap newStoryDataWrap">
                                <Col xs={24} sm={24} md={24} lg={24}>
                                    {/* <div className="ag-theme-alpine storyDataUpr">
                                        {dataLoading ? (
                                            <Loading />
                                        ) : (<AgGridReact
                                            rowData={rowData}
                                            columnDefs={columnDefs}
                                            defaultColDef={defaultColDef}
                                            suppressRowClickSelection={true}
                                            className="storyData"
                                            rowHeight={50}
                                            gridOptions={{
                                                getRowStyle: params => {
                                                    if (params.node.rowIndex === 0) {
                                                        return { background: COLOR.lightgreen };
                                                    }
                                                },
                                            }}
                                            columnHoverHighlight={true}>
                                        </AgGridReact>)}
                                    </div> */}
                                    <div className="ag-theme-alpine storyDataUpr" style={{ marginTop:24 }}>
                                    <GradeTable
                                        activities={activities}
                                        currentClass={currentClass}
                                        currentOrg={currentOrg}
                                        dataLoading={dataLoading}
                                        quizzes={quizzes}
                                        submissions={submissions}
                                        users={filteredStudent}
                                        booksAllList={booksAllList}
                                        isReviewAccount={false}
                                        handleEditQuiz={quiz => {
                                            openEditQuiz(quiz);
                                        }}
                                        handleEditActivity={activity => {
                                            openEditActivity(activity);
                                        }}
                                        currentUser={currentUser}
                                        classActivities={classActivityData}
                                        getAssignmentCreation={getAssignmentCreation}
                                        classQuizzes={classQuizzesData}
                                        handleoverAllShow={handleoverAllShow}
                                        handleGradeValueShow={handleGradeValueShow}
                                        reviewAssignment={reviewAssignment}
                                        userPreference={userPreference}
                                    />
                                    </div>
                                </Col>
                            </Row>
                            {/* End of Data Table  */}

                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </>);
};
const mapStateToProps = state => ({
    classActivities: state.classActivities,
    classQuizzes: state.classQuizzes,
    currentUser: state.currentUser,
    classUsers: state.classUsers,
    currentClass: state.currentClass,
    currentOrg: state.currentOrg,
    submissions: state.submissions,
    booksAllList: state.booksAllList,
    userPreference: state.userPreference,
    activities: state.activities,
    quizzes: state.quizzes,
});

export default connect(mapStateToProps, null)(GridStoryLevel); 